import AddressLineOne from './AddressLineOne';


class PostCode extends AddressLineOne {

    static defaultProps = {
        'field': 'postcode',
        'id': 'postcode'
    };

}



export default PostCode;
